import { useCallback, useEffect, useState } from "react";
import { Marker, Pane, Tooltip } from "react-leaflet";
import L, { MarkerCluster, divIcon, icon } from "leaflet";
import { useAppSelector } from "Hooks/useRedux";
import MarkerClusterGroup from "react-leaflet-cluster";
import useTrafficFleet from "Hooks/useTrafficFleet";
import { renderToStaticMarkup } from "react-dom/server";
import { Box, Card, Stack, Typography } from "@mui/material";
import Icon from "Components/Icon";

const ICON_SIZE = 22;

export default function TrafficFleetMarkerCluster() {
  const { zone } = useAppSelector((state) => state.zones);
  const { visible } = useAppSelector((state) => state.trafficFleet);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useTrafficFleet();
  const [radius, setRadius] = useState<number>(50);

  const handleSourcesMarker = (traffics: any) => {
    return traffics?.map((item: any, indx: number) => {
      if (!item.TTO_Data) return;
      const traffic = JSON.parse(`{${item.TTO_Data}}`);

      const fleetIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            color: "#000",
            width: "40px",
            height: "40px",
            backgroundColor: "#fff0",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#000",
            display: "grid",
            placeItems: "center",
            transform: ` scale(${Math.log2(Number(traffic.TTO) + 1)} ,${Math.log2(Number(traffic.TTO) + 1)} )`,
          }}
        >
          <Icon icon="directions_car" />
        </Box>
      );

      const fleetIcon = divIcon({
        html: fleetIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
      });

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }} className="fa-number">
            <Stack alignItems="center">
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography> {traffic.DeviceName} </Typography>
                <Typography> : نام سامانه </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.DeviceCode}</Typography>
                <Typography> : کد سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.TTO}</Typography>
                <Typography> : تعداد دفعات مشاهده </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.First}</Typography>
                <Typography> : نخستین مشاهده </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.Last}</Typography>
                <Typography> : آخرین مشاهده </Typography>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      );
      return (
        <Marker position={[traffic.GeographicalAccident, traffic.GeographicalLength]} icon={fleetIcon}>
          {tooltipContent}
        </Marker>
      );
    });
  };

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return L.divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: L.point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      {" "}
      <Pane name={`${Math.random()}show_survay_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <MarkerClusterGroup chunkedLoading maxClusterRadius={radius} iconCreateFunction={createSourceCustomIcon}>
          {handleSourcesMarker(data)}
        </MarkerClusterGroup>
      </Pane>
    </>
  );
}
